// extracted by mini-css-extract-plugin
module.exports = {"list":"ExpertiseBox_list__185eH","listItem":"ExpertiseBox_listItem__OTscr"};